<template>
  <div>
    <div class="biz-active-item">
      <!-- 没数据时 -->
      <div v-if="config.link_data && config.link_data.length == 0">
        <div
          v-if="config.style_type == 1"
          class="services-item-double-con"
          style="font-size: 0"
        >
          <div class="services-item-double-item">
            <p class="effectivity-time">11.1-11.15</p>
            <div class="img-wra">
              <img
                src="https://img.mockuai.com/tms/2018/1/10/upload_48dfb5b82f032311cb9207f142a95b89.png"
              />
              <p class="goods-tag">商品标签</p>
            </div>
            <div style="padding: 10px">
              <span class="title-text-14 text-1-line">商品标题</span>
              <div class="services-item-double-price">
                <div style="color: #ec4000" v-if="app_type === 'seller'">
                  <p class="price-font-10">预计赚</p>
                  <p class="price-font-num-14 ft500">
                    <span style="font-size: 8px">¥</span>4.38
                  </p>
                </div>
                <div v-if="app_type === 'seller'">
                  <p class="price-font-10">佣金</p>
                  <p class="price-font-num-14 ft500">15.16%</p>
                </div>
                <div :class="app_type === 'buyer' ? 'inline' : ''">
                  <p class="price-font-10 label">活动价</p>
                  <p class="price-font-num-14 ft500">
                    <span style="font-size: 8px">¥</span>28.9
                  </p>
                </div>
              </div>
              <div class="item_buy">
                <span>{{ btn_text }}</span><van-icon name="arrow" />
              </div>
            </div>
          </div>
          <div class="services-item-double-item">
            <p class="effectivity-time">11.1-11.15</p>
            <div class="img-wra">
              <img
                src="https://img.mockuai.com/tms/2018/1/10/upload_48dfb5b82f032311cb9207f142a95b89.png"
              />
              <p class="goods-tag">商品标签</p>
            </div>
            <div style="padding: 10px">
              <span class="title-text-14">商品标题</span>
              <div class="services-item-double-price">
                <div style="color: #ec4000" v-if="app_type === 'seller'">
                  <p class="price-font-10">预计赚</p>
                  <p class="price-font-num-14 ft500">
                    <span style="font-size: 8px">¥</span>4.38
                  </p>
                </div>
                <div v-if="app_type === 'seller'">
                  <p class="price-font-10">佣金</p>
                  <p class="price-font-num-14 ft500">15.16%</p>
                </div>
                <div :class="app_type === 'buyer' ? 'inline' : ''">
                  <p class="price-font-10 label">活动价</p>
                  <p class="price-font-num-14 ft500">
                    <span style="font-size: 8px">¥</span>28.9
                  </p>
                </div>
              </div>
              <div class="item_buy">
                <span>{{ btn_text }}</span><van-icon name="arrow" />
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="config.style_type == 2">
          <div class="services-item-one-item">
            <p class="effectivity-time effectivity-time2">11.1-11.15</p>
            <div class="img-wra style2">
              <img
                src="https://img.mockuai.com/tms/2018/1/10/upload_48dfb5b82f032311cb9207f142a95b89.png"
              />
              <p class="goods-tag">商品标签</p>
            </div>
            <div
              style="
                flex: 1;
                margin-left: 10px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
              "
            >
              <div class="title-text-14 text-2-line">商品标题</div>
              <p>
                <van-tag type="primary" color="#ffe1e1" text-color="#FF254C"
                  >运营标签</van-tag
                >
              </p>
              <div
                class="flex-row-center"
                style="justify-content: space-between; width: inherit"
              >
                <div>
                  <div class="price-font-12" v-if="app_type === 'seller'">
                    佣金 <span class="ft500" style="font-size: 16px">12%</span>
                  </div>
                  <div
                    class="price-font-12"
                    :class="app_type === 'buyer' ? 'inline' : ''"
                  >
                    活动价
                    <span class="ft500" style="font-size: 14px">¥88</span>
                  </div>
                </div>
                <div class="three_buy">
                  <span>{{ btn_text }}</span><van-icon name="arrow" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="config.style_type == 3" class="services-item-three-con">
          <div v-for="n in 3" :key="n" class="services-item-three-item">
            <div>
              <div class="services-item-three-img">
                <p class="effectivity-time effectivity-time3">11.1-11.15</p>
                <img
                  src="https://img.mockuai.com/tms/2018/1/10/upload_48dfb5b82f032311cb9207f142a95b89.png"
                />
                <p class="goods-tag">商品标签</p>
              </div>
              <div class="flex-column-center">
                <span
                  class="title-text-12 text-1-line"
                  style="line-height: 21px; text-align: left"
                  >商品标题</span
                >
                <div class="services-item-three-item-price">
                  <div v-if="app_type === 'seller'">佣金 10.21%</div>
                  <div class="services-item-three-bot">
                    <span>活动价 ¥8.00 </span>
                    <div class="btn-arrow"><van-icon name="arrow" /></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--   有数据时 -->
      <div v-else-if="config.link_data">
        <div v-if="config.style_type == 1">
          <div
            class="services-item-double-con"
            style="font-size: 0"
            v-for="index in Math.ceil(config.link_data.length / 2)"
            :key="index"
          >
            <div
              class="services-item-double-item"
              :style="{ background: config.bg_color }"
              @click="jump(config.link_data[(index - 1) * 2])"
            >
              <p class="effectivity-time" :style="{ background: btn_bg, color:config.tips_color }">
                {{ effectivity }}
              </p>
              <div class="img-wra">
                <img
                  :src="config.link_data[(index - 1) * 2].icon"
                  class="is-live"
                />
                <p
                  v-if="config.link_data[(index - 1) * 2].recommend_reason"
                  :style="{ background: btn_bg, color:config.tips_color }"
                  class="goods-tag"
                >
                  {{ config.link_data[(index - 1) * 2].recommend_reason | spl }}
                </p>
              </div>
              <div style="padding: 8px 10px 10px">
                <span :style="{ color: config.font_color }" class="title-text-14 text-1-line">{{
                  config.link_data[(index - 1) * 2].item_name
                }}</span>
                <!--卖家-->
                <div class="services-item-double-price" :style="{ color: config.font_color }">
                  <div :style="{ color: config.price_font_color }" v-if="app_type === 'seller'">
                    <p class="price-font-10">预计赚</p>
                    <p class="price-font-num-14 ft500">
                      <span style="font-size: 8px">¥</span
                      >{{
                        ((config.link_data[(index - 1) * 2] || {})
                          .live_promotion_profit || 0) | filterPrice
                      }}
                    </p>
                  </div>
                  <div v-if="app_type === 'seller'">
                    <p class="price-font-10">佣金</p>
                    <p class="price-font-num-14 ft500">
                      {{
                        ((config.link_data[(index - 1) * 2] || {})
                          .live_commission_percent || 0) | filterPrice
                      }}%
                    </p>
                  </div>
                  <div :class="app_type === 'buyer' ? 'inline' : ''">
                    <p class="price-font-10 label">活动价</p>
                    <p class="price-font-num-14 ft500">
                      <span style="font-size: 8px">¥</span
                      >{{
                        ((config.link_data[(index - 1) * 2] || {}).live_price ||
                          0) | filterPrice
                      }}
                    </p>
                  </div>
                </div>
                <div class="item_buy" :style="{ color: config.btn_font_color,background: config.btn_bg_color }">
                  <span>{{
                    app_type == "seller" ? "立即上架" : `${btn_text}`
                  }}</span><van-icon name="arrow" />
                </div>
              </div>
            </div>

            <div
              class="services-item-double-item"
              :style="{ background: config.bg_color }"
              @click="jump(config.link_data[index * 2 - 1])"
              v-if="
                index * 2 < config.link_data.length ||
                ((index * 2) % 2 === 0 && index * 2 === config.link_data.length)
              "
            >
              <p class="effectivity-time" :style="{ background: btn_bg, color:config.tips_color }">
                {{ effectivity }}
              </p>
              <div class="img-wra">
                <img
                  :src="config.link_data[index * 2 - 1].icon"
                  class="is-live"
                />
                <p
                  v-if="
                    config.link_data[index * 2 - 1] &&
                    config.link_data[index * 2 - 1].recommend_reason
                  "
                  :style="{ background: btn_bg, color:config.tips_color }"
                  class="goods-tag"
                >
                  {{
                    (config.link_data[index * 2 - 1] || {}).recommend_reason
                      | spl
                  }}
                </p>
              </div>
              <div style="padding: 8px 10px 10px">
                <span :style="{ color: config.font_color }" class="title-text-14 text-1-line">{{
                  config.link_data[index * 2 - 1].item_name
                }}</span>
                <div class="services-item-double-price" :style="{ color: config.font_color }">
                  <div :style="{ color: config.price_font_color }" v-if="app_type === 'seller'">
                    <p class="price-font-10">预计赚</p>
                    <p class="price-font-num-14 ft500">
                      <span style="font-size: 8px">¥</span
                      >{{
                        ((config.link_data[index * 2 - 1] || {})
                          .live_promotion_profit || 0) | filterPrice
                      }}
                    </p>
                  </div>
                  <div v-if="app_type === 'seller'">
                    <p class="price-font-10">佣金</p>
                    <p class="price-font-num-14 ft500">
                      {{
                        ((config.link_data[index * 2 - 1] || {})
                          .live_commission_percent || 0) | filterPrice
                      }}%
                    </p>
                  </div>
                  <div :class="app_type === 'buyer' ? 'inline' : ''">
                    <p class="price-font-10 label">活动价</p>
                    <p class="price-font-num-14 ft500">
                      <span style="font-size: 8px">¥</span
                      >{{
                        ((config.link_data[index * 2 - 1] || {}).live_price ||
                          0) | filterPrice
                      }}
                    </p>
                  </div>
                </div>
                <div class="item_buy" :style="{ color: config.btn_font_color,background: config.btn_bg_color }">
                  <span>{{
                    app_type == "seller" ? "立即上架" : `${btn_text}`
                  }}</span><van-icon name="arrow" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="config.style_type == 2">
          <div class="item-2">
            <div
              class="services-item-one-item"
              @click="jump(item)"
              v-for="(item, index) in config.link_data"
              :key="index"
              :style="{ background: config.bg_color }"
            >
              <p
                class="effectivity-time effectivity-time2"
                :style="{ background: btn_bg, color:config.tips_color }"
              >
                {{ effectivity }}
              </p>
              <div class="img-wra style2">
                <img :src="item.icon" class="is-live" />
                <p
                  v-if="item.recommend_reason"
                  :style="{ background: btn_bg, color:config.tips_color }"
                  class="goods-tag"
                >
                  {{ item.recommend_reason | spl }}
                </p>
              </div>
              <div
                style="
                  flex: 1;
                  margin-left: 10px;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                "
              >
                <div class="title-text-14 text-2-line" :style="{ color: config.font_color }">
                  {{ item.item_name }}
                </div>
                <p>
                  <span v-for="(tag, i) in item.operation_tags" :key="i">
                    <van-tag
                      type="primary"
                      :color="config.font_color"
                      :text-color="config.bg_color"
                      v-if="tag.tag"
                      style="border: 0; margin: 2px"
                      >{{ tag.tag }}</van-tag
                    >
                  </span>
                </p>
                <!--卖家-->
                <div>
                  <div
                    class="flex-row-center"
                    style="justify-content: space-between; width: inherit"
                  >
                    <div>
                      <div class="price-font-12" :style="{ color: config.price_font_color }" v-if="app_type === 'seller'">
                        佣金
                        <span class="ft500"
                          ><span style="font-size: 15px">{{
                            (item.live_commission_percent || 0) | filterPrice
                          }}</span
                          >%</span
                        >
                      </div>
                      <div class="price-font-12" :style="{ color: config.price_font_color }">
                        活动价
                        <span style="font-size: 15px" class="ft500"
                          >¥{{ (item.live_price || 0) | filterPrice }}</span
                        >
                      </div>
                    </div>
                    <div class="three_buy" :style="{ color: config.btn_font_color,background: config.btn_bg_color }">
                      <span>{{ btn_text }}</span><van-icon name="arrow" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="config.style_type == 3" class="services-item-three-con">
          <div
            v-for="(service, index) in config.link_data"
            :key="index"
            :style="{ background: config.bg_color }"
            @click="jump(service)"
            class="services-item-three-item"
          >
            <div>
              <div class="services-item-three-img">
                <p
                  class="effectivity-time effectivity-time3" :style="{ background: btn_bg, color:config.tips_color }"
                >
                  {{ effectivity }}
                </p>
                <img :src="service.icon" class="is-live" />
                <p v-if="service.recommend_reason" class="goods-tag" :style="{ background: btn_bg, color:config.tips_color }">
                  {{ service.recommend_reason | spl }}
                </p>
              </div>
              <div class="flex-column-center">
                <div
                  class="title-text-13 text-2-line"
                  style="line-height: 18px; text-align: left; min-height: 36px"
                  :style="{ color: config.font_color }"
                >
                  {{ service.item_name }}
                </div>
                <div class="services-item-three-item-price" :style="{ color: config.price_font_color }">
                  <div v-if="app_type === 'seller'">
                    佣金
                    {{ (service.live_commission_percent || 0) | filterPrice }}%
                  </div>
                  <div class="services-item-three-bot">
                    <span
                      >活动价 ¥{{
                        (service.live_price || 0) | filterPrice
                      }}</span
                    >
                    <div class="btn-arrow" :style="{ color: config.btn_font_color, background: config.btn_bg_color }"><van-icon name="arrow" /></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { redirectURL } from "@/js/jump";
export default {
  name: "tms-active-item",
  props: ["config", "theme", "isEditorStatus", "pageData"],

  data() {
    return {
      buyer_list_id: "",
      item_ids: [],
    };
  },
  computed: {
    themeObj() {
      return {
        background: this.theme.color,
        boxShadow: "0 1px 4px 0 " + this.toRgba(this.theme.color, 0.5),
      };
    },
    btn_bg() {
      return this.config.tips_bg_color;
    },
    btn_text() {
      return this.config.property_data.btn_text;
    },
    // 生效时间
    effectivity() {
      let start_time = this.jointTime(
        this.config.active_item.start_time || "2020-12-12 00:00:00"
      );
      let end_time = this.jointTime(
        this.config.active_item.end_time || "2020-12-12 00:00:00"
      );
      return `${start_time}-${end_time}`;
    },
    app_type() {
      return this.pageData.app_type || "seller";
    },
  },
  components: {},
  created() {
    const ua = window.navigator.userAgent;
    if (
      this.config.link_data &&
      this.config.link_data.length &&
      (ua.indexOf("Mockuai") > -1 || ua.indexOf("Wdzg") > -1) &&
      this.app_type === "seller"
    ) {
      this.buyer_list_id = this.config.link_data[0].buyer_list_id;
      this.config.link_data.forEach((item) => {
        if (item.item_id) {
          this.item_ids.push(item.item_id);
        }
      });
      this.getGoodList();
    }
  },
  methods: {
    jump(item) {
      if (this.isEditorStatus) {
        return;
      }
      this.$emit("report", {
        btn: "0001",
        type: "u_click",
        params: { item_id: item.item_id },
      });
      redirectURL(item.item_id.toString(), this.app_type);
    },
    toRgba(color, opacity) {
      const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      let sColor = color.toLowerCase();
      if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
          let sColorNew = "#";
          for (let i = 1; i < 4; i += 1) {
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
          }
          sColor = sColorNew;
        }
        //处理六位的颜色值
        let sColorChange = [];
        for (let i = 1; i < 7; i += 2) {
          sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
        }
        return "rgba(" + sColorChange.join(",") + "," + opacity + ")";
      } else {
        return sColor;
      }
    },
    jointTime(time) {
      const newArr = time.split(" ")[0].split("-");
      return `${newArr[1]}.${newArr[2]}`;
    },
    getGoodList() {
      lib.api.get({
        api: "ec/b/operation/buyer/item/list",
        data: {
          item_ids: this.item_ids.join(","), // '1652334,9358170',
          id: this.buyer_list_id, // 2976
        },
        success: (res) => {
          if (res.data && res.data.length) {
            const data = res.data;
            let temps = [];
            this.item_ids.forEach((item_id) => {
              let res = data.find((i) => i.item_id === item_id);
              if(res && this.config.link_data[i] && this.config.link_data[i].operation_tags){
                res.operation_tags = this.config.link_data[i].operation_tags;
              }
              res && temps.push(res);
            });
            this.config.link_data = temps;
          }
        },
        error: (data) => {},
        complete: () => {},
      });
    },
  },
  filters: {
    spl(val) {
      if (!val) {
        return "";
      }
      return val.substr(0, 8);
    },
  },
};
</script>

<style  lang="scss" scoped>
@import "./index.scss";
</style>